
import Visual1 from "../../../img/screenshots/dmo/dmo-feature-01.png";
import Visual2 from "../../../img/screenshots/dmo/dmo-feature-02.png";
import Visual3 from "../../../img/screenshots/dmo/dmo-feature-03.png";
import Visual4 from "../../../img/screenshots/dmo/dmo-feature-04.png";



export const DmoFeaturesContent = [
    { 
      title:"Stay present throughout the entire travel journey",     
      subtitle:"Be there before, during & after",      
      text:"Stippl allows you to offer your content and itineraries for travellers to customise, so every destination, accommodation, restaurant, or highlight becomes a dynamic piece of content carrying your stamp of recommendation.",
      image:Visual1
    },
    { 
      title:"Easy to maintain, not a lot of time needed",     
      subtitle:"Give your existing content a boost",      
      text:"With Stippl you can easily update and highlight existing content, instead of having to constantly create new content. This allows DMOs to save time and focus on other promotional activities.",
      image:Visual2
    },
    { 
      title:"Option to stand out by promoting hidden gems at your destination",     
      subtitle:"Guide tourists to new places ",      
      text:"With Stippl DMOs can easily create visually appealing itineraries that showcase the unique and lesser-known attractions in their destination. This can help to entice potential visitors and increase tourism to these areas.",
      image:Visual3
    },
    { 
      title:"A new & dynamic way to inspire tourists",     
      subtitle:"Empower tourists with actionable content",      
      text:"Stippl offers a dynamic way for tourists to plan and explore a destination by providing personalised recommendations in one place, which is a stark comparison to traditional static website content. DMOs can showcase their destinations in an interactive and personalised way, inspiring tourists to visit and experience it in a new and exciting way.",
      image:Visual4
    }
  ]